import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


//components
import {VendorLineItemEditComponent} from '../../components/Editors/VendorLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-vendorlineitem-grid',
  templateUrl: './VendorLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => VendorLineItemGridComponent)}]
})
export class VendorLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.VendorLineItem[] = [];
    selectedLineItems: ent.VendorLineItem[] = [];
    editedLineItem: ent.VendorLineItem;

    cols: any[];

    @Input() public maxLineItemCount: number;
    @Input() public showEquipmentLocationOnGrid: boolean;
    
    @ViewChild(VendorLineItemEditComponent) public vendorLineItemEdit: VendorLineItemEditComponent;
    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    
    vendSizes: ent.VendSize[] = [];
    flavors: ent.Flavor[] = [];
    cardReaders: ent.CardReader[] = [];
    securityLevels: ent.SecurityLevel[] = [];
    vendSizeFlavorXrefs: ent.VendSizeFlavorXref[] = [];

    vendSizeSelectItems: SelectItem[] = [];
    flavorSelectItems: SelectItem[] = [];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

        
   

    ngOnInit(): void {
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'VendSize.Name', header: 'Vend Size' }
            // { field: 'brand', header: 'Brand' },
            // { field: 'color', header: 'Color' }
        ];

        var results = this.domainDataService.getVendSizeFlavorXrefsFromCache();
        results.forEach(y=>this.vendSizeFlavorXrefs.push(y));
        
        this.editedLineItem = new ent.VendorLineItem();
        this.load();
    }

    public load(){
      
        var filter: filters.VendSizeFilter = {};
        this.domainDataService.getVendSizes(filter).subscribe(x=> this.onGetVendSizesDone(x));
        var flavorFilter: filters.FlavorFilter = {};
        this.domainDataService.getFlavors(flavorFilter).subscribe(x=> this.onGetFlavorsDone(x));
        this.domainDataService.getCardReaders().subscribe(x=> this.onGetCardReadersDone(x));
        this.domainDataService.getSecurityLevels().subscribe(x=> this.onGetSecurityLevelsDone(x));
    }
    
    onGetVendSizesDone(items: ent.VendSize[]){
        items.forEach(y=> this.vendSizes.push(y));

        this.vendSizeSelectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.vendSizeSelectItems.push({label:y.Name, value:y.ID}));

    }

    onGetFlavorsDone(items: ent.Flavor[]){
        items.forEach(y=> this.flavors.push(y));
        this.flavorSelectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.flavorSelectItems.push({label:y.Name, value:y.ID}));

    }

    onGetCardReadersDone(items: ent.CardReader[]){
        items.forEach(y=> this.cardReaders.push(y));
    }

    onGetSecurityLevelsDone(items: ent.SecurityLevel[]){
        items.forEach(y=> this.securityLevels.push(y));
    }
    
    onAddClick(event: any){
      
        this.editedLineItem = new ent.VendorLineItem();
        this.vendorLineItemEdit.lineItem = new ent.VendorLineItem();
        this.vendorLineItemEdit.vendSizeDropdown.value = null;
        this.vendorLineItemEdit.flavorDropdown.value = null;
        // this.vendorLineItemEdit.cardReaderDropdown.value = null;
        // this.vendorLineItemEdit.securityLevelDropdown.value = null;
        this.vendorLineItemEdit.displayDialog = true;
    }

    onAddLineItemClick(event: any){
        if (!this.lineItems){this.lineItems = []}
        var newLineItem = new ent.VendorLineItem();
        //this.lineItems = <VendorLineItem[]>this.addLineItem(newLineItem, this.lineItems);

        this.lineItems = [...this.lineItems, newLineItem];
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onDeleteClick(event: any, lineItem: ent.VendorLineItem){
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onEditClick(event: any, lineItem: ent.VendorLineItem){
        
        this.editedLineItem = lineItem;
        this.vendorLineItemEdit.lineItem = lineItem;
        this.vendorLineItemEdit.vendSizeDropdown.value = this.editedLineItem.VendSize.ID;
        this.vendorLineItemEdit.flavorDropdown.value = this.editedLineItem.Flavor.ID;
        // this.vendorLineItemEdit.securityLevelDropdown.value = this.editedLineItem.SecurityLevel.ID;
        // this.vendorLineItemEdit.cardReaderDropdown.value = this.editedLineItem.CardReader.ID;
        this.vendorLineItemEdit.displayDialog = true;
    }

    onVendorLineItemEditOK(){
        
        if (this.editedLineItem.VendSizeID && this.editedLineItem.VendSizeID > 0){
            var vendSize = this.vendSizes.filter(x=>x.ID == this.editedLineItem.VendSizeID)[0];
            this.editedLineItem.VendSize = {ID: vendSize.ID, Name: vendSize.Name, Inactive: vendSize.Inactive};
            //this.editedLineItem.VendSizeID = vendSize.ID;
        }

        if (this.editedLineItem.FlavorID && this.editedLineItem.FlavorID > 0){
            var flavor = this.flavors.filter(x=>x.ID == this.editedLineItem.FlavorID)[0];
            this.editedLineItem.Flavor = {ID: flavor.ID, Code: flavor.Code, Name: flavor.Name, Inactive: flavor.Inactive};
            //this.editedLineItem.FlavorID = flavor.ID;
        }

        // if (this.editedLineItem.CardReaderID && this.editedLineItem.CardReaderID > 0){
        //     var cardReader = this.cardReaders.filter(x=>x.ID == this.editedLineItem.CardReaderID)[0];
        //     this.editedLineItem.CardReader = {ID: cardReader.ID, Name: cardReader.Name};
        //     //this.editedLineItem.CardReaderID = cardReader.ID;
        // }

        // if (this.editedLineItem.SecurityLevelID && this.editedLineItem.SecurityLevelID > 0){
        //     var securityLevel = this.securityLevels.filter(x=>x.ID == this.editedLineItem.SecurityLevelID)[0];
        //     this.editedLineItem.SecurityLevel = {ID: securityLevel.ID, Name: securityLevel.Name};
        //     //this.editedLineItem.SecurityLevelID = securityLevel.ID;
        // }

        this.lineItems = <ent.VendorLineItem[]>this.addLineItem(this.editedLineItem, this.lineItems);
    }

    enableAddButton(): boolean {
        var val: boolean;

        if (!this.lineItems || !this.maxLineItemCount || (this.maxLineItemCount && this.lineItems.length < this.maxLineItemCount)){
            val = true;
        }
        return val;
    }

    vendSizeChange(event: any, lineItem: ent.VendorLineItem){
        var vendSize = this.vendSizes.filter(x=>x.ID == event)[0];
        if (!lineItem.VendSize || lineItem.VendSize.ID != vendSize.ID){
            lineItem.VendSize = vendSize;
            lineItem.VendSizeID = vendSize.ID;

            this.setMaterialNumberAndDescription(lineItem);
            //console.info("vendSizeChange: changed lineItem.VendSizeID to " + vendSize.ID);
        }
        
    }

    flavorChange(event: any, lineItem: ent.VendorLineItem){
        var flavor = this.flavors.filter(x=>x.ID == event)[0];
        if (!lineItem.Flavor || lineItem.Flavor.ID != flavor.ID){
            lineItem.Flavor = flavor;
            lineItem.FlavorID = flavor.ID;
            this.setMaterialNumberAndDescription(lineItem);
            //console.info("vendSizeChange: changed lineItem.VendSizeID to " + vendSize.ID);
        }
        
    }

    setMaterialNumberAndDescription(lineItem: ent.VendorLineItem){
        lineItem.MaterialNumber = "";
        lineItem.MaterialDescription = "";
        var matchingRecords = this.vendSizeFlavorXrefs.filter(x=>x.FlavorID == lineItem.FlavorID && x.VendSizeID == lineItem.VendSizeID);
        if (matchingRecords && matchingRecords.length > 0){
            lineItem.MaterialNumber = matchingRecords[0].MaterialNumber;
            lineItem.MaterialDescription = matchingRecords[0].MaterialDescription;
        }
    }

    

}